import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { CART_EMPTY } from '../constants/cartConstants';
import { ID_RESET } from '../constants/idConstants';
import { getStore } from '../actions/storeActions';
import {
  STORE_UNAVAILABLE_ALERT_TRIGGER,
} from '../constants/storeConstants';
import useAxios from '../axios/useAxios';
import { userInitialPromo } from '../actions/userActions';
import {
  HOME,
  NUMBER_SCREEN,
  SET_ACCOUNT,
  STORE_LIST,
} from '../constants/routes';
import { isAppPWA } from '../utils/helper-functions';
import { useUserLoginStatus } from '../utils/hooks';
import AnimatedLoader from '../components/AnimatedLoader/AnimatedLoader';
import { getTheme } from '../actions/themeActions';
import { useFunnelTracking } from '../posthog/funnelTracking';
import { isOlderThan30Minutes } from '../utils/date-helper';

const RedirectPage = () => {
  const navigate = useNavigate();
  const [, setReset] = useState(false);
  const { store } = useSelector((state) => state.store);
  const user = useSelector((state) => state.user);
  const conecs = useSelector((state) => state.conecs);
  const edenred = useSelector((state) => state.edenred);
  const creditCard = useSelector((state) => state.creditCard);
  const { success, loading } = useSelector((state) => state.store);
  const themeState = useSelector((state) => state.theme) || {};
  const [, setIsLoading] = useState(true);
  // hooks
  const isLoggedIn = useUserLoginStatus();
  const isPWA = isAppPWA();

  // const axiosInstance = config()
  const axiosInstance = useAxios();
  const dispatch = useDispatch();
  // console.log(axiosInstance);

  const location =
    new URLSearchParams(window.location.search).get('ok') ||
    user?.favoriteStore;

  const entryQr = new URLSearchParams(window.location.search).get('qr') || '';

  const cb = new URLSearchParams(window.location.search).get('cb');

  const { trackPageViewRedirect } = useFunnelTracking();

  useEffect(() => {
    trackPageViewRedirect({
                        entryQr: entryQr,
                        location: location,
                        isPWA: isPWA,
                        isLoggedIn: isLoggedIn,
                        user: user,
                      });
  }, [trackPageViewRedirect]);

  useEffect(() => {
    window.scrollTo(0, 0);
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 1500);
    return () => {
      clearTimeout(timer);
    };
  }, []);

  useEffect(() => {
    dispatch(getTheme(axiosInstance));
    if (edenred?.username && edenred.username.length > 0) {
      user.edenred = edenred;
      const newUser = JSON.parse(localStorage.getItem('user')) || {};
      newUser.edenred = edenred;
      localStorage.setItem('user', JSON.stringify(newUser));
    }

    if (
      conecs?.buyerId &&
      conecs.buyerId.length > 0 &&
      conecs.reuse === true
    ) {
      user.conecs = conecs;
      const newUser = JSON.parse(localStorage.getItem('user')) || {};
      newUser.conecs = conecs;
      localStorage.setItem('user', JSON.stringify(newUser));
    }
    if (
      creditCard?.id &&
      creditCard.id.length > 0 &&
      creditCard.saveCard === true
    ) {
      user.creditCard = [creditCard];
      const newUser = JSON.parse(localStorage.getItem('user')) || {};
      newUser.creditCard = [creditCard];
      localStorage.setItem('user', JSON.stringify(newUser));
    }
    if (cb) {
      user.creditCard = [JSON.parse(cb)];
    }

    if(entryQr){
      localStorage.setItem('entryQr', entryQr);
    }

    dispatch(userInitialPromo(user, axiosInstance));

    const cartItems = localStorage.getItem('cartItems') || '{}'
    const cartItemsParsed = JSON.parse(cartItems)

    if (isOlderThan30Minutes(cartItemsParsed?.createdAt)) {
      dispatch({ type: CART_EMPTY });
      dispatch({ type: ID_RESET });
    }

    setReset(true);
    localStorage.removeItem('receipt_url');
    localStorage.removeItem('animSuccess');
    localStorage.removeItem('welcome');
  }, []);

  useEffect(() => {
    if (location) {
      dispatch(getStore(location, axiosInstance));
      localStorage.removeItem('isCheckStore');
    }else{
      handleNavigation();
    }
  }, [location]);

  useEffect(() => {
    if (store && !store.live) {
      localStorage.setItem(
        STORE_UNAVAILABLE_ALERT_TRIGGER,
        JSON.stringify({ isTriggered: false }),
      );
      navigate(STORE_LIST, { state: { storeLocked: true } });
      return;
    }
  }, [store]);

  useEffect(() => {
    if (loading) {
      return;
    }
    if (themeState.loading) {
      return;
    }
    if (!localStorage.getItem('store')) {
      return;
    }
    handleNavigation();
  }, [loading, themeState.loading]); // Dependencies to re-trigger navigation logic
  const handleNavigation = () => {
    if (isPWA) {
      if (isLoggedIn && !user.favoriteStore) {
        navigate(SET_ACCOUNT, { state: { entryQr: entryQr || '' } });
      } else if (!isLoggedIn) {
        navigate(NUMBER_SCREEN, { state: { userNotConnected: true } });
      } else if (success && themeState.theme.confettis) {
        navigate(HOME, { state: { entryQr: entryQr || '' } });
      } else {
        navigate(HOME, { state: { entryQr: entryQr || '' } });
      }
    } else {
      if (success && themeState.theme.confettis) {
        navigate(HOME, { state: { entryQr: entryQr || '' } });
      } else {
        navigate(STORE_LIST, { state: { entryQr: entryQr || '' } });
      }
    }
  };

  return (
    <>
      <AnimatedLoader />
    </>
  );
};

export default RedirectPage;
